import { CorporateAdmins } from '@platform/client';
import type { CohortData } from '@platform/client/schemas';
import { Tabs } from '@platform/components';
import { AcceptedStatusTable } from './applicants-table/AcceptedStatusTable';
import { droppedColumns, pendingColumns, rejectedColumns } from './applicants-table/columns';
import { StatusTable } from './applicants-table/StatusTable';

export const ApplicantsTable = ({
  cohortId,
  cohort,
}: {
  cohortId: number;
  cohort: CohortData;
}) => {
  const { data, isLoading, isError } = CorporateAdmins.useGetApplicants(cohortId);

  if (isError) return <div>Error loading applicants</div>;
  if (isLoading || !data) return <div>Loading applicants...</div>;

  const items = [
    {
      id: 'accepted',
      label: 'Accepted',
      content: <AcceptedStatusTable data={data.accepted} cohort={cohort} />,
    },
    {
      id: 'pending',
      label: 'Pending',
      content: <StatusTable data={data.pending} columns={pendingColumns} />,
    },
    {
      id: 'rejected',
      label: 'Rejected',
      content: <StatusTable data={data.rejected} columns={rejectedColumns} />,
    },
    {
      id: 'dropped',
      label: 'Dropped',
      content: <StatusTable data={data.dropped} columns={droppedColumns} />,
    },
  ].map((tab) => ({
    id: tab.id,
    tabLabel: <span>{tab.label}</span>,
    content: tab.content,
  }));

  return (
    <Tabs
      title='Applicants by status'
      variant='segmented'
      items={items}
      defaultSelectedKey='accepted'
    />
  );
};
